import { nanoid } from "nanoid";

export const generateId = () => nanoid();
